import { vservice } from '@niknevis/vue-modules'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { AdminChangelogRoute } from '@/modules/changelog/routes/admin-changelog.route'
import { ChangelogCollectionModel } from '@/modules/changelog/models/changelog-collection.model'
import { Paginated } from '@/modules/shared/models/data'

@vservice()
export class AdminChangelogService {
  constructor(
    private readonly routes: AdminChangelogRoute
  ) {
  }

  getChangelogs(modelId: number, modelType: string, page: number): Promise<Paginated<ChangelogCollectionModel[]>> {
    return HTTP.get(
      this.routes.changelog(modelId, modelType),
      { searchParams: { page, model_id: modelId, model_type: modelType } }
    ).then(response => response.json())
  }
}
